/**
 * Domain values that arrive from the API as Bulgarian text.
 *
 * These are DATA, not UI text. The server sends them and the frontend matches them
 * verbatim — translating a literal here silently changes behaviour. Compare against
 * the constants; translate only at the render boundary, via the label helpers.
 */

/**
 * policy.policyType, as sent by the Amarant API.
 * Guards in PoliciesComponent compare against this exact string. Do NOT translate it.
 */
export const POLICY_TYPE_HEALTH = "Здравна застраховка";

/**
 * System (tenant) ids used to gate tenant-specific UI. These are the production
 * `_id` values — the codebase hardcodes prod system ids throughout, so the same
 * value applies across environments.
 */

/** ImmoAssist system. The "Create offers" chat action is hidden for this tenant. */
export const SYSTEM_ID_IMMOASSIST = "6a549b9a606bf906cf416732";

/**
 * Translate a policyType for display. Unknown types fall through to the raw server
 * value rather than rendering blank — the API's vocabulary is open-ended and only
 * the health type is known to the frontend.
 */
export const policyTypeLabel = (policyType, t) => {
  if (!policyType) return policyType;
  if (policyType === POLICY_TYPE_HEALTH) return t("policies:type.health");
  return policyType;
};

/**
 * Search fields for the topics toolbar. `value` is sent to the API as a query key
 * (`{ [value]: inputValue }`) and must stay Latin; `labelKey` is display only.
 *
 * Shared by Topics.js (which renders the selected label) and LeftToolbar.js (which
 * renders the radio options). These were duplicated literals in both files with
 * nothing linking them — translating one and not the other silently mismatched the
 * dropdown against its own radio buttons.
 */
export const SEARCH_FIELDS = [
  { value: "title", labelKey: "search.byTitle" },
  { value: "keyword", labelKey: "search.byKeyword" },
  { value: "responsible", labelKey: "search.byAssignee" },
  { value: "customer", labelKey: "search.byCustomer" },
];

export const DEFAULT_SEARCH_FIELD = "title";

/** Period filter for the topics toolbar. `value` is sent to the API. */
export const SEARCH_PERIODS = [
  { value: "created", labelKey: "search.periodCreated" },
  { value: "activity", labelKey: "search.periodActivity" },
];

export const DEFAULT_SEARCH_PERIOD = "created";

export const getSearchFieldLabelKey = (value) =>
  (SEARCH_FIELDS.find((f) => f.value === value) || SEARCH_FIELDS[0]).labelKey;

export const getSearchPeriodLabelKey = (value) =>
  (SEARCH_PERIODS.find((p) => p.value === value) || SEARCH_PERIODS[0]).labelKey;
